<div class="maintenance-dialog-overlay">
   <div class="maintenance-dialog-container">
     <p class="maintenance-dialog-header-text">Application maintenance has begun</p>
     <p class="saving-text">{{ savingText }}</p>
     <p class="maintenance-dialog-info-text">{{ statusText }}</p>
   </div>
</div>
